import { useLocalization } from "@fluent/react";
import { Button, Row } from "@narmi/design_system";
import { Dialog } from "cerulean";

type DisableAdminExemptionDialogProps = {
  isOpen: boolean;
  onConfirm: () => void | Promise<void>;
  onDismiss: () => void;
};

const DisableAdminExemptionDialog = ({
  isOpen,
  onConfirm,
  onDismiss,
}: DisableAdminExemptionDialogProps) => {
  const { l10n } = useLocalization();

  return (
    <Dialog
      isOpen={isOpen}
      onUserDismiss={onDismiss}
      title={l10n.getString("admin-exemption-label")}
      testId="disable-exemption-confirm"
      footer={
        <Row alignItems="center" justifyContent="end">
          <Row.Item shrink>
            <Button
              kind="negative"
              label={l10n.getString("button-cancel")}
              testId="cancel-disable-exemption"
              onClick={onDismiss}
            />
          </Row.Item>
          <Row.Item shrink>
            <Button
              kind="primary"
              label={l10n.getString(
                "admin-exemption-button-confirm-turn-off"
              )}
              testId="confirm-disable-exemption"
              onClick={onConfirm}
            />
          </Row.Item>
        </Row>
      }
    >
      <p>
        {l10n.getString("admin-exemption-confirm-disable-paragraph-1")}
      </p>
      <p>
        {l10n.getString("admin-exemption-confirm-disable-paragraph-2")}
      </p>
    </Dialog>
  );
};

export default DisableAdminExemptionDialog;
